module.exports = __webpack_public_path__ + "static/img/target_a1.306e40b4.png";